<template>
    <div class="header-nav">
        <div class="label" 
            v-for="(route, index) in routes.data" 
            :key="index"
            @click="goPath(route)">
            <span class="label-text"
                v-if="!route.children || !route.children.length">
                <span :style="_textStyle(route.active)">{{ $getConfigText(route.name) }}</span>
            </span>
            <div class="menu" v-else>
                <div class="menu-name">
                    <span class="label-text" :style="_textStyle(route.active)">
                        <span>{{ $getConfigText(route.name) }}</span>
                        <i class="el-icon-arrow-up icon-up"></i>
                        <i class="el-icon-arrow-down icon-down"></i>
                    </span>
                </div>
                <div class="menu-list">
                    <div class="menu-item" 
                        v-for="item in route.children" 
                        :key="item.menuId" 
                        @click.stop="goSecondPath(item, route)">
                        <span>{{ $getConfigText(item.name) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.header-nav{
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
}
.label{
    position: relative;
    display: flex;
    align-items: center;
    height: 80px;
    padding: 0 20px;
    .label-text{
        color: var(--menuTextColor);
        cursor: pointer;
    }
    .menu{
        display: flex;
        align-items: center;
        height: 100%;
        .menu-name{
            .icon-up{
                display: none;
                font-size: 16px;
            }
            .icon-down{
                display: inline;
                font-size: 16px;
            }
        }
        .menu-list{
            display: none;
            position: absolute;
            top: 80px;
            left: 0;
            z-index: 1000;
            line-height: normal;
            padding: 15px 20px;
            border-bottom-left-radius: 3px;
            border-bottom-right-radius: 3px;
            box-shadow: 0px 3px 6px 1px rgba(51, 51, 51, 0.1);
            background: var(--menuListBg);
            .menu-item{
                display: flex;
                align-items: center;
                width: max-content;
                margin-bottom: 15px;
                cursor: pointer;
                span{
                    font-size: 16px;
                    color: var(--menuTextColor);
                }
                &:hover{
                    span{
                        color: var(--menuSelectedColor);
                    }
                }
                &:nth-last-child(1){
                    margin-bottom: 0;
                }
            }
        }
    }
    &:hover{
        .menu-name{
            .icon-up{
                display: inline;
            }
            .icon-down{
                display: none;
            }
        }
        .menu-list{
            display: block;
        }
    }
    &:nth-child(1){
        margin-left: 40px;
    }
}
</style>

<script>
export default {
    props: {
        routes: Object
    },
    methods: {
        goPath(route){
            if(route.children && route.children.length){
                return
            }
            if(route.isFrame){
                window.open(route.path)
            }else{
                window.location.href = route.path
            }
            this.routes.setActive(route)
        },
        goSecondPath(item, route){
            if(item.isFrame){
                window.open(item.path)
            }else{
                window.location.href = item.path
            }
            this.routes.setActive(route)
        },
        _textStyle(active){
            return active ? `color: var(--menuSelectedColor);` : ''
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/header/nav/index.vue